import React, { useState, useEffect } from "react";
import "./TableList.css";

const RowList = (props) => {
  const { data, dataFull, machineTrackList, nestedTableConfig } = props;
  const keys = Object.keys(data);
  const [operations, setOperations] = useState(null);

  useEffect(() => {
    if (!nestedTableConfig) {
      setOperations(null);
      return;
    }
    const {
      matchRowField,
      matchFullField,
      operationsField,
      columns,
      customRender,
    } = nestedTableConfig;
    if (
      !matchRowField ||
      !matchFullField ||
      !operationsField ||
      !columns ||
      !Array.isArray(columns)
    ) {
      setOperations(null);
      return;
    }
    if (dataFull.length > 0) {
      let infos = dataFull.find((e) => e[matchFullField] == data[matchRowField]);
      if (infos && infos[operationsField]) {
        if (typeof customRender === "function") {
          setOperations(customRender(infos[operationsField], infos, data));
        } else {
          let op = (
            <table className="nested-table">
              <thead>
                <tr>
                  {columns.map((col, idx) => (
                    <th key={idx}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {infos[operationsField].map((row, idx) => (
                  <tr key={idx}>
                    {columns.map((col, cidx) => (
                      <td key={cidx}>
                        {typeof col.key === "function"
                          ? col.key(row, infos, data)
                          : row[col.key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          );
          setOperations(op);
        }
      } else {
        setOperations(null);
      }
    } else {
      setOperations(null);
    }
  }, [dataFull, data, nestedTableConfig]);

  return (
    <>
      <tr key={data.id}>
        {machineTrackList
          ? keys.map((key, index) =>
              index === 0 ? (
                <td key={key}>{data[key]}</td>
              ) : (
                <td key={key}>
                  <input />
                </td>
              )
            )
          : keys.map((key) => <td key={key}>{data[key]}</td>)}
      </tr>
      {operations !== null ? (
        <tr className="operationsTable">
          <td colSpan={keys.length}>
            <details>
              <summary>Ver operações</summary>
              {operations}
            </details>
          </td>
        </tr>
      ) : null}
    </>
  );
};

const TableList = ({ data, machineTrackList, dataFull = [], nestedTableConfig, columns }) => {
  const [keys, setKeys] = useState([]);
  const [completeData, setCompleteData] = useState([]);

  useEffect(() => {
    if (columns && Array.isArray(columns) && columns.length > 0) {
      setKeys(columns.map(col => typeof col === 'string' ? col : col.label));
    } else if (data.length > 0) {
      setKeys(Object.keys(data[0]));
    }
  }, [data, columns]);

  useEffect(() => {
    if (dataFull.length > 0) {
      setCompleteData(dataFull);
    } else {
      setCompleteData([]);
    }
  }, [dataFull]);

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            {keys.map((item, idx) => (
              <th
                style={{ position: "sticky", top: 0, background: "white" }}
                key={idx}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((rowData, index) => (
            <RowList
              data={rowData}
              key={index}
              dataFull={completeData}
              machineTrackList={machineTrackList}
              nestedTableConfig={nestedTableConfig}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableList;